export default "__VITE_ASSET__054a9815__"